export default function ConfirmDialog({
  open,
  title = '提示',
  detail,
  message,
  confirmLabel = '確認',
  cancelLabel = '取消',
  confirming = false,
  onConfirm,
  onClose,
}) {
  if (!open) {
    return null;
  }

  return (
    <div className="confirm-dialog-overlay" role="presentation" onClick={onClose}>
      <div
        className="confirm-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirm-dialog__content">
          <div className="confirm-dialog__icon" aria-hidden="true">
            !
          </div>
          <div className="confirm-dialog__text">
            <h4 id="confirm-dialog-title">{title}</h4>
            {detail && <p className="confirm-dialog__detail">{detail}</p>}
            {message && <p className="confirm-dialog__message">{message}</p>}
          </div>
        </div>
        <div className="confirm-dialog__actions">
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={confirming}>
            {cancelLabel}
          </button>
          <button type="button" className="btn btn-primary" onClick={onConfirm} disabled={confirming}>
            {confirming ? '處理中…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
